import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import { STORAGE } from "../../constant/storages";
import { _getStorage } from "../../utils/local-storage";

@Injectable({
  providedIn: "root",
})
export class CreditNoteService {
  response: any;
  datasave: any;
  reqBody: any;

  constructor(public storage: Storage) {}

  async setData() {
    const res =await _getStorage(STORAGE.searchCreditNode);
    this.reqBody = res.request;
    this.response = res.response;
  }

  async setTaxinvoiceList(data: any) {
    console.log('setTaxinvoiceList=====: ',data)
    this.reqBody = {};
    this.response = {};
    this.datasave = {};

    await this.setData();
    this.datasave = data;

    let line_product = [];
    for (let p of this.response.res_rts.salesTicket[0].products) {
      line_product.push({
        product_line: p.seq,
        product_barcoce: p.barcode,
        product_sku: p.sku,
        product_nameTH: p.productNameTH,
        product_qty: p.qty,
        product_unit_price: p.amtPerQty,
        product_discount: p.discountAmt,
        product_vat: p.vatAmt,
        product_total_price: p.amtExdiscount,
      });
    }

    let address = !this.datasave[0].hasOwnProperty("address_detail")
      ? this.datasave[0]
      : this.datasave[0].address_detail[0];
    return {
      abb_no: this.response.res_rts.salesTicket[0].receiptNo,
      date_time: this.getDate(),
      ref_abb_no: this.response.res_rts.salesTicket[0].refTicket.receiptNo,
      tax_invoice_no: "",
      ref_tax_invoice_no:
        this.response.abb_data.length == 0
          ? "N/A"
          : this.response.abb_data[0].taxinvoice_no,
      tax_cid_no: this.reqBody.cn_cid,
      branch_no:
        this.datasave[0].buyer_main_branch_no != ""
          ? this.datasave[0].buyer_main_branch_no
          : this.datasave[0].buyer_branch_no,
      cn_no: "",
      buyer: {
        buyer_id: this.datasave[0].buyer_id,
        name_info: {
          type: this.datasave[0].buyer_type,
          name: this.datasave[0].buyer_company_name,
          buyer_cid: this.datasave[0].buyer_tax_id,
          branch:
            this.datasave[0].buyer_main_branch_no != ""
              ? this.datasave[0].buyer_main_branch_no
              : this.datasave[0].buyer_branch_no,
        },
        address_info: {
          addr_id: address.addr_id,
          building_no: address.building_no,
          building_name: address.building_name,
          house_no: address.house_no,
          village_no: address.village_no,
          lane: address.lane,
          road: address.road,
          sub_district: address.sub_district,
          district: address.district,
          province: address.province,
          postcode: address.postcode,
          phone: address.phone,
          email: this.datasave[0].buyer_type ==="1"?"":address.email || "",
          display_address:
            address.type_addr === "1" ? address.addr_info : address.addr_infoEN,
        },
      },
      product: {
        total_include_vat: this.response.res_rts.salesTicket[0].totalNetSaleAmt,
        vat: this.response.res_rts.salesTicket[0].taxValue,
        total_exclude_vat:
          this.response.res_rts.salesTicket[0].totalAmtExdiscount,
        line: line_product,
      },
    };
  }

  getDate() {
    let d = new Date();
    return d.getDate() + "/" + (d.getMonth() + 1) + "/" + d.getFullYear();
  }
}
